"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenTypes = exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var tokenTypes = exports.tokenTypes = {
  ciam: 'ciam',
  mw: 'mw'
};
var ActivityWatcher = /*#__PURE__*/function () {
  function ActivityWatcher() {
    (0, _classCallCheck2.default)(this, ActivityWatcher);
  }
  (0, _createClass2.default)(ActivityWatcher, null, [{
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return new Date().getTime() / 1000 * 1;
    }
  }, {
    key: "addListener",
    value: function addListener(listener) {
      this.intervalListeners.push(listener);
    }
  }, {
    key: "getLastActivtyTimestamp",
    value: function getLastActivtyTimestamp() {
      return sessionStorage.lastActivityTimestamp;
    }
  }, {
    key: "registerNewActivity",
    value: function registerNewActivity() {
      sessionStorage.lastActivityTimestamp = this.getCurrentTime();
    }
  }, {
    key: "registerTokenRefreshing",
    value: function registerTokenRefreshing() {
      var _this = this;
      for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }
      types.forEach(function (type) {
        sessionStorage["".concat(type, "TokenRefresh")] = _this.getCurrentTime();
        sessionStorage["".concat(type, "TokenRefreshIsGoingOn")] = '';
      });
    }
  }, {
    key: "cleanupLocalData",
    value: function cleanupLocalData() {
      Object.values(tokenTypes).forEach(function (type) {
        sessionStorage["".concat(type, "TokenRefresh")] = '';
        sessionStorage["".concat(type, "TokenRefreshIsGoingOn")] = '';
      });
      sessionStorage.lastActivityTimestamp = '';
    }
  }, {
    key: "calculateLastActivityInterval",
    value: function calculateLastActivityInterval() {
      return this.getCurrentTime() - parseInt(this.getLastActivtyTimestamp(), 10);
    }
  }, {
    key: "registerActivityListeners",
    value: function registerActivityListeners() {
      var _this2 = this;
      var eventCalculator = function eventCalculator() {
        if (_this2.calculateLastActivityInterval() > 5) {
          _this2.registerNewActivity();
          _this2.refreshTokens();
        }
      };
      window.addEventListener('mousemove', eventCalculator);
      window.addEventListener('touchend', eventCalculator);
      window.addEventListener('touchstart', eventCalculator);
      window.addEventListener('touchmove', eventCalculator);
      window.addEventListener('scroll', eventCalculator);
      window.addEventListener('keypress', eventCalculator);
    }
  }, {
    key: "itHasValidLocks",
    value: function itHasValidLocks(type) {
      var tokenTimer = type === tokenTypes.ciam ? sessionStorage.ciamTokenRefreshIsGoingOn : sessionStorage.mwTokenRefreshIsGoingOn;
      return tokenTimer && this.getCurrentTime() - tokenTimer < 60;
    }
  }, {
    key: "refreshTokens",
    value: function refreshTokens() {
      var _this3 = this;
      var lastRefreshCiam = sessionStorage.ciamTokenRefresh || 0;
      var lastRefreshMw = sessionStorage.mwTokenRefresh || 0;
      var timeToUpdateToken = function timeToUpdateToken(lastTokenRefresh) {
        return _this3.getCurrentTime() - lastTokenRefresh > _this3.timoeoutInterval / 2;
      };
      if (timeToUpdateToken(lastRefreshCiam) && !this.itHasValidLocks(tokenTypes.ciam)) {
        var _this$refreshCiamToke;
        sessionStorage.ciamTokenRefreshIsGoingOn = this.getCurrentTime();
        // @TODO In CC-mode the refreshCiamToken is undefined, this is a temporary solution to avoid the error
        (_this$refreshCiamToke = this.refreshCiamToken()) === null || _this$refreshCiamToke === void 0 ? void 0 : _this$refreshCiamToke.then(function () {
          _this3.registerTokenRefreshing(tokenTypes.ciam);
        }).catch(function () {
          sessionStorage.ciamTokenRefreshIsGoingOn = '';
        });
      }
      if (timeToUpdateToken(lastRefreshMw) && !this.itHasValidLocks(tokenTypes.mw)) {
        sessionStorage.mwTokenRefreshIsGoingOn = this.getCurrentTime();
        this.refreshMiddlewareToken().then(function () {
          _this3.registerTokenRefreshing(tokenTypes.mw);
        }).catch(function () {
          sessionStorage.mwTokenRefreshIsGoingOn = '';
        });
      }
    }
  }, {
    key: "initActivityObserving",
    value: function initActivityObserving() {
      var _this4 = this;
      var timoeoutInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 540;
      var refreshCiamToken = arguments.length > 1 ? arguments[1] : undefined;
      var refreshMiddlewareToken = arguments.length > 2 ? arguments[2] : undefined;
      var sessionTerminator = arguments.length > 3 ? arguments[3] : undefined;
      if (this.activityObserver) {
        return;
      }
      this.refreshCiamToken = refreshCiamToken;
      this.refreshMiddlewareToken = refreshMiddlewareToken;
      this.timoeoutInterval = timoeoutInterval;
      this.registerActivityListeners();
      var observer = function observer() {
        var lastActivityHappened = _this4.calculateLastActivityInterval();
        _this4.intervalListeners.forEach(function (listener) {
          return listener(lastActivityHappened, timoeoutInterval);
        });
        if (isNaN(lastActivityHappened) || lastActivityHappened > timoeoutInterval) {
          sessionTerminator();
          if (_this4.activityObserver) {
            clearInterval(_this4.activityObserver);
          }
        }
      };
      this.activityObserver = setInterval(observer, 5000);
      observer();
    }
  }, {
    key: "clearObserver",
    value: function clearObserver() {
      if (this.activityObserver) {
        clearInterval(this.activityObserver);
        delete this.activityObserver;
      }
    }
  }]);
  return ActivityWatcher;
}();
(0, _defineProperty2.default)(ActivityWatcher, "activityObserver", void 0);
(0, _defineProperty2.default)(ActivityWatcher, "timoeoutInterval", void 0);
(0, _defineProperty2.default)(ActivityWatcher, "refreshCiamToken", void 0);
(0, _defineProperty2.default)(ActivityWatcher, "refreshMiddlewareToken", void 0);
(0, _defineProperty2.default)(ActivityWatcher, "intervalListeners", []);
var _default = exports.default = ActivityWatcher;